import React, { useEffect } from 'react';
import { useController, useFormContext } from 'react-hook-form';
import Select from 'react-select';
import ErrorMessage from '@components/profile/profileOverlay/common/ErrorMessage';
import { ReactSelectStyles } from '@components/profile/profileOverlay/overlays/ReactSelectStyles';
import styles from '../../militaryPreference.module.scss';
import { disabilityGradeOptions, disabilityOptions } from '@domain/constant/profile/PreferentialType';
import classnames from 'classnames/bind';

const cx = classnames.bind(styles);

const DisabilityForm = () => {
  const fieldName = 'disability';
  const { control, getValues } = useFormContext();
  const isDisabilityNone = getValues('disability.grade')?.value === 'NONE' || !getValues('disability.grade')?.value;

  const gradeName = `${fieldName}.grade`;
  const {
    field: gradeField,
    fieldState: gradeMeta,
    formState: { errors: gradeErrors },
  } = useController({
    name: gradeName,
    control,
  });

  const typeName = `${fieldName}.type`;
  const {
    field: typeField,
    fieldState: typeMeta,
    formState: { errors: typeErrors },
  } = useController({
    name: typeName,
    control,
  });

  useEffect(() => {
    if (isDisabilityNone) {
      typeField.onChange(null);
    }
  }, [isDisabilityNone, typeField]);

  return (
    <div className={cx('infoArea', 'disability')}>
      <em className={cx('infoTitle')}>장애 사항</em>
      <div className={cx('selectArea')}>
        <div className={cx('selectWrap')}>
          <Select
            {...gradeField}
            className={cx('select', { error: gradeMeta.invalid })}
            placeholder={'장애 등급'}
            styles={ReactSelectStyles}
            isSearchable={false}
            options={disabilityGradeOptions}
          />
          <ErrorMessage errors={gradeErrors} name={gradeName} />
        </div>
        <div className={cx('selectWrap', 'type2')}>
          <Select
            {...typeField}
            className={cx('select', { error: isDisabilityNone && typeMeta.invalid })}
            placeholder={'내용을 선택해 주세요.'}
            styles={ReactSelectStyles}
            isSearchable={false}
            options={disabilityOptions}
            isDisabled={isDisabilityNone}
          />
          {isDisabilityNone && <ErrorMessage errors={typeErrors} name={typeName} />}
        </div>
      </div>
    </div>
  );
};

export default DisabilityForm;
